import { ParentChildCommonProps } from "PFComponents/experience_level/experience_level.types";
import { CustomValue, Experience } from "PFTypes";

import { RatingDotsProps } from "../rating_dots/rating_dots";
import { ExperienceLevelTooltipContentRequired } from "./experience_level_tooltip_content_required";
import { ProfileExperienceTooltipContent } from "./parts/profile_experience_tooltip_content";

type ExperienceLevelTooltipContentProps = Pick<RatingDotsProps, "shape"> & {
  customValue?: CustomValue;
  experience?: Experience | null;
  requiredExperience?: Experience | null;
  experienceLevels: Experience[];
  experienceLabelMap: Record<Experience, string>;
} & ParentChildCommonProps;

export const ExperienceLevelTooltipContent = ({
  experience,
  requiredExperience,
  hasParentValues,
  hasChildValues,
  shape,
  experienceLevels,
  experienceLabelMap
}: ExperienceLevelTooltipContentProps) => {
  const commonProps = {
    experience,
    hasChildValues,
    hasParentValues,
    experienceLevels,
    experienceLabelMap
  };

  return requiredExperience ? (
    <ExperienceLevelTooltipContentRequired {...commonProps} requiredExperience={requiredExperience} />
  ) : (
    <ProfileExperienceTooltipContent {...commonProps} shape={shape} showTitle={false} />
  );
};
